import { Component, Input } from '@angular/core';
import { DetectPlatformService } from '../../../services/detectPlatform.service';

@Component({
  selector: 'app-link-button',
  templateUrl: './app-link-button.component.html',
  styleUrls: ['./app-link-button.component.scss']
})
export class AppLinkButtonComponent {
  @Input() type = 'primary';

  constructor(public detectPlatformService: DetectPlatformService) {}
}
